var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h2', {
    staticClass: "tit tit--lg"
  }, [_vm._v("응찰안내")])]), _c('div', {
    staticClass: "tab-wrap"
  }, [_c('v-tabs', {
    staticClass: "tab tab--underline",
    attrs: {
      "value": _vm.tab,
      "grow": "",
      "show-arrows": "",
      "center-active": ""
    }
  }, _vm._l(_vm.tabs, function (_ref) {
    var value = _ref.value,
        text = _ref.text;
    return _c('v-tab', {
      key: value,
      attrs: {
        "to": "/how-to/".concat(value)
      }
    }, [_c('span', [_vm._v(_vm._s(text))])]);
  }), 1)], 1), _c('v-tabs-items', {
    attrs: {
      "value": _vm.tab,
      "touchless": ""
    }
  }, [_c('how-to-bid-join'), _c('how-to-bid-preview'), _c('how-to-bid-online'), _c('how-to-bid-live'), _c('how-to-bid-notice'), _c('how-to-bid-success'), _c('how-to-bid-delivery')], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }